
import {Model} from '@/store/models/model'
import axios from "@/store/vue-axios"
import User  from "@/store/models/user"
import Domain from "@/store/models/domain/domain";
import DomainHandle from "@/store/models/domain/domain_handle";


export class UserConfigDefaults extends Model {

  static entity = 'userconfigdefaults'
  static primaryKey = 'user'

  static fields() {
    return {
      user:this.attr(null),
      ns1: this.attr(null),
      ns2: this.attr(null),
      ns3: this.attr(null),
      ns4: this.attr(null),
      ns5: this.attr(null),
      ownerC: this.attr(null),
      adminC: this.attr(null),
      techC: this.attr(null),
      zoneC:this.attr(null),
      domain_defaults_ns_first:this.attr(null),
      domain_defaults_ns_second:this.attr(null),
      mail_default_name:this.attr(null),
      mail_default_address:this.attr(null),
      notifications_fromSubaccount_undefined:this.attr(null),
      email_default_address:this.attr(null),
      email_default_name:this.attr(null),
      email_support_address:this.attr(null),
      email_support_name:this.attr(null),
      email_status_address:this.attr(null),
      email_status_name:this.attr(null),
      phpunit_text_config:this.attr(null),
      phpunit_text_protected:this.attr(null),
      domain_defaults_ns_third:this.attr(null),
      domain_defaults_ns_fourth:this.attr(null),
      domain_defaults_ns_fifth:this.attr(null),
      domain_defaults_ownerC:this.attr(null),
      domain_defaults_adminC:this.attr(null),
      domain_defaults_techC:this.attr(null),
      domain_defaults_zoneC:this.attr(null),
      email_billing_address:this.attr(null),
      email_billing_name:this.attr(null)
  }
  }

  static mainKeys =[
    "ns1",
    "ns2",
    "ns3",
    "ns4",
    "ns5",
    "ownerC",
    "adminC",
    "techC",
    "zoneC"
  ]
  static handleKeys =[
    "ownerC",
    "adminC",
    "techC",
    "zoneC"
  ]
  static nameserverKeys = [
    "ns1",
    "ns2",
    "ns3",
    "ns4",
    "ns5"
  ]
  static api_namserverKeys = {
    first:"ns1",
    second:"ns2",
    third:"ns3",
    fourth:"ns4",
    fifth:"ns5"
  }

  static async getConfigs(user){
    console.log('GET CONFIG USER STATUS', user)
    const obj = {}
    obj['user']=user
    const res = await axios.get('account/configs')
        .then((response)=> {
          const x = Object.keys(response.data.configs).map(el=>{
                const key = el.split('.')
                // CREATE NEW KEY xx.xx.xx => xx_xx_xx
                let new_key = ''
                const keymap = key.map((i)=>{
                    new_key.length < 1 ? new_key+= i : new_key+= '_'+i
                    }
                  )
                // GENERATE OBJECT FOR MODEL INSERTION
                obj[new_key] = response.data.configs[el]
                let k = key.slice( -1 )[ 0 ]
                // HANDLES
                const h = this.handleKeys.includes( k )
                          ? obj[ k ] = response.data.configs[ el ][ 'value' ] //?  response.data.configs[ el ][ 'value' ] : ' '
                          : undefined
                // NAMESERVER
                const n = this.nameserverKeys.includes(k)
                          ? obj[ k ] = response.data.configs[ el ][ 'value' ] //?  response.data.configs[ el ][ 'value' ] : ' '
                          : undefined
                //NAMESERVER DEPRECATED
                // const n = this.api_namserverKeys[ k.split('_')[ 1 ] ]
                //           ? obj[ this.api_namserverKeys[ k.split('_')[1] ] ] = response.data.configs[ el ][ 'value' ]
                //           : undefined
              }
          )
        })
      .catch(error=>error)
    this.insertOrUpdate({data:obj})
    return this.find(user)
  }

// DEPRECATED !!!!
//   static async fetchOrUpdateConf(data=0){
//     const username = User.currentUser().username
//     if (data !== 0) return UserConfigDefaults.insertOrUpdate( {where:username, data:data})
//     const response = await axios.get('account/configs')
//
//     console.log('User.currentUser().user.username::::',username)
//
//     if(response.data.configs && username) {
//       const d = {
//         user : username, // CHECK IF USERNAME ON ADMINC ALWAYS CORRECTS
//         ownerC: !response.data.configs['domain.defaults.ownerC'] || response.data.configs['domain.defaults.ownerC'].value === null  ? 'option' :  response.data.configs['domain.defaults.ownerC'].value,
//         adminC: !response.data.configs['domain.defaults.adminC']   ? 'option' : response.data.configs['domain.defaults.adminC'].value,
//         techC: !response.data.configs['domain.defaults.techC'] ? 'option' : response.data.configs['domain.defaults.techC'].value,
//         zoneC: !response.data.configs['domain.defaults.zoneC'] ? 'option' : response.data.configs['domain.defaults.zoneC'].value,
//         ns1:!response.data.configs['domain.defaults.ns1'] ? 'option' : response.data.configs['domain.defaults.ns1'].value,
//         ns2:!response.data.configs['domain.defaults.ns2'] ? 'option' : response.data.configs['domain.defaults.ns2'].value,
//         ns3: !response.data.configs['domain.defaults.ns3'] || response.data.configs['domain.defaults.ns3'].value === null ? 'option' : response.data.configs['domain.defaults.ns3'].value ,
//         ns4:!response.data.configs['domain.defaults.ns4'] || response.data.configs['domain.defaults.ns4'].value === null ? 'option' : response.data.configs['domain.defaults.ns4'].value,
//         ns5:!response.data.configs['domain.defaults.ns5'] || response.data.configs['domain.defaults.ns5'].value === null  ? 'option' : response.data.configs['domain.defaults.ns5'].value
//       }
//       UserConfigDefaults.insertOrUpdate({data:d})
//       this.pushHandles(username)
//     }
//   }
//   static pushHandles(username){
//     const x = UserConfigDefaults.query().where('user',username).get()[0]
//     Domain.contacts.map(el=>{
//       console.log('userconf pushHandles:::', x[el])
//       DomainHandle.fetch(x[el])
//     })
//   }

  static beforeSave(data, prefix = null){
    console.log("CONFIGDATA--", data);
    const x = Object.assign({},data)
    if(x.$id) delete x.$id
    const request={}
    const y = Object.keys(x).map(el=>{
      if(x[el] === 'option' || x[el] === null || x[el] === undefined ){ delete x[el]}
      let key = (prefix ? prefix + '.' : '') +el
      request[key] = x[el]
    })
    // if(x.$id) delete x.$id
    return request
  }

  static save(data, prefix = null){
    const x = this.beforeSave(data, prefix  )
    const z = axios.put('/account/configs',x)
      .then(response => {
        console.log(response.data)
      })
      .catch(error=>error)
  }

  /*static refreshNameserver(){
    const y = UserConfigDefaults.query().find(this.user.username)
    const x = Object.assign({},y)
    delete x.adminC
    delete x.ownerC
    delete x.techC
    delete x.zoneC
    delete x.user
    if(x.ns1 === 'option') delete x.ns1
    if(x.ns2 === 'option') delete x.ns2
    if(x.ns3 === 'option') delete x.ns3
    if(x.ns4 === 'option') delete x.ns4
    if(x.ns5 === 'option') delete x.ns5

    delete x.$id
    console.log('xxxxx::::',x)
    const z =  axios.post("/domain/nameservers/refresh", x)
  }*/

}



export default UserConfigDefaults



// WEBPACK FOOTER //
// ./src/store/models/layout/user_config.js